import { webKnots } from '../../../../common/back/lace/webKnots'
import { jointOfCatchFace, jointOfIndexFinger, jointOfThumbFinger2 } from './parts/earJointParts'
import { topSidePartOfWebForPicher } from './parts/sideParts'

export const type6Web = (ctx: CanvasRenderingContext2D, webColor: string, laceColor: string, stitchColor: string): void => {
  ctx.lineWidth = 0.8
  ctx.strokeStyle = '#282828'
  // web先端の革パーツ
  topSidePartOfWebForPicher(ctx, webColor, laceColor, stitchColor)
  // ウェブ-人差し指のジョイントパーツ
  jointOfIndexFinger(ctx, webColor, laceColor, 3, 30)
  jointOfIndexFinger(ctx, webColor, laceColor, -24, 90)
  jointOfIndexFinger(ctx, webColor, laceColor, -45, 160)
  jointOfCatchFace(ctx, webColor, laceColor, -10, 12)
  jointOfCatchFace(ctx, webColor, laceColor, 38, 57)
  jointOfThumbFinger2(ctx, webColor, laceColor, 53, -56)
  jointOfThumbFinger2(ctx, webColor, laceColor, 19, -30)
  jointOfThumbFinger2(ctx, webColor, laceColor, -18, -5)
  // web本体のflatパーツ
  ctx.fillStyle = webColor
  ctx.beginPath()
  ctx.moveTo(549, 81) // 左上
  ctx.quadraticCurveTo(502, 166, 482, 247) // 左下1
  ctx.quadraticCurveTo(480, 256, 486, 268) // 左下2
  ctx.quadraticCurveTo(516, 326, 565, 357) // 右下1
  ctx.quadraticCurveTo(571, 362, 582, 362) // 右下2
  ctx.quadraticCurveTo(637, 324, 693, 280) // 右上
  ctx.quadraticCurveTo(660, 140, 549, 81) // 左上
  ctx.fill()
  // 左上
  ctx.moveTo(559, 87)
  ctx.quadraticCurveTo(566, 122, 562, 167) // 右
  ctx.quadraticCurveTo(556, 133, 543, 116) // 左
  ctx.quadraticCurveTo(533, 111, 533, 111) // 左
  // 左中
  ctx.moveTo(514, 151)
  ctx.quadraticCurveTo(514, 185, 537, 222) // 右下1
  ctx.quadraticCurveTo(549, 231, 556, 220) // 右下2
  ctx.quadraticCurveTo(584, 162, 590, 162) // 上1
  ctx.quadraticCurveTo(605, 145, 627, 185) // 上2
  ctx.quadraticCurveTo(666, 299, 666, 299) // 右上

  // 左下
  ctx.moveTo(490, 218)
  ctx.quadraticCurveTo(511, 251, 541, 282) // 右下1
  ctx.quadraticCurveTo(555, 289, 564, 266) // 右下2
  ctx.quadraticCurveTo(584, 191, 584, 191) // 上1
  ctx.quadraticCurveTo(590, 173, 598, 190) // 上2
  ctx.quadraticCurveTo(635, 324, 635, 324) // 右下

  // 下
  ctx.moveTo(568, 358) //下
  ctx.quadraticCurveTo(591, 271, 591, 271) // 上
  ctx.quadraticCurveTo(588, 304, 590, 324) // 右下1
  ctx.quadraticCurveTo(593, 340, 605, 342) // 右下2

  ctx.stroke()
  ctx.closePath()

  // stitchここから
  ctx.beginPath()
  ctx.strokeStyle = stitchColor
  ctx.setLineDash([3, 3])
  // 外側
  ctx.moveTo(552, 87) // 左上
  ctx.quadraticCurveTo(508, 166, 486, 252) // 左下
  ctx.quadraticCurveTo(505, 318, 581, 358) // 右下
  ctx.quadraticCurveTo(630, 326, 689, 277) //
  // 左上
  ctx.moveTo(564, 90) // 左上
  ctx.quadraticCurveTo(571, 137, 561, 177) //
  ctx.quadraticCurveTo(551, 128, 540, 119) // 左下
  ctx.quadraticCurveTo(520, 163, 520, 163) //
  ctx.quadraticCurveTo(522, 182, 536, 211) //
  ctx.quadraticCurveTo(543, 228, 553, 216) //
  ctx.quadraticCurveTo(566, 184, 583, 161) //
  ctx.quadraticCurveTo(601, 143, 618, 164) //
  ctx.quadraticCurveTo(638, 188, 668, 288) //
  ctx.quadraticCurveTo(690, 270, 689, 274) //
  ctx.quadraticCurveTo(650, 138, 551, 87) //
  // 左下
  ctx.moveTo(495, 230) // 左上
  ctx.quadraticCurveTo(490, 252, 490, 252) // 左下
  ctx.quadraticCurveTo(516, 321, 567, 345) // 右下
  ctx.quadraticCurveTo(575, 301, 594, 258) //
  ctx.quadraticCurveTo(593, 322, 593, 322) //
  ctx.quadraticCurveTo(597, 342, 607, 335) //
  ctx.quadraticCurveTo(629, 319, 629, 319) //
  ctx.quadraticCurveTo(594, 189, 594, 189) //
  ctx.quadraticCurveTo(590, 178, 585, 199) //
  ctx.quadraticCurveTo(569, 265, 569, 265) //
  ctx.quadraticCurveTo(556, 298, 536, 283) //
  ctx.quadraticCurveTo(492, 230, 492, 230) //
  // ctx.quadraticCurveTo() //
  ctx.stroke()
  ctx.setLineDash([])
  ctx.strokeStyle = laceColor
  ctx.closePath()
  // stitchここまで
  webKnots(ctx, laceColor, -110, 110, 1) // ウェブ先端寄りのウェブ結び目
}
